import clsx from 'clsx';
import { memo } from 'react';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

import { MenuSection } from '../interfaces';

const useStyles = makeStyles((theme: Theme) => ({
  title: {
    color: theme.palette.primary.contrastText
  },
  center: {
    display: 'flex',
    justifyContent: 'center'
  }
}));

interface Props extends Pick<MenuSection, 'title'> {
  isShrinked: boolean;
}

const MenuTitle = ({ title, isShrinked }: Props) => {
  const classes = useStyles();

  return (
    <Box mr={1} ml={1} mb={1} className={clsx(isShrinked && classes.center)}>
      <Typography className={classes.title} variant="body1">
        {title}
      </Typography>
    </Box>
  );
};

export default memo(MenuTitle);
